"use client";
import React, { ReactNode, Dispatch, SetStateAction } from "react";
import { Button } from "@heroui/button";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@heroui/modal";
import { Spinner } from "@heroui/spinner";

import useConfirmAlert from "./useConfirmAlert";

interface Props {
  approveText?: string;
  cancelText?: string;
  approveColor?: any;
  cancelColor?: any;
  showLoading?: boolean;
  title: string;
  description: string | ReactNode;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  approveAction: () => void;
}
const ConfirmAlert = ({
  approveText = "Ok",
  cancelText = "Cancel",
  approveColor = "danger",
  cancelColor = "primary",
  showLoading = false,
  title,
  description,
  isOpen,
  setIsOpen,
  approveAction,
}: Props) => {
  const {} = useConfirmAlert();

  return (
    <div>
      <Modal
        hideCloseButton
        backdrop="blur"
        isDismissable={false}
        isOpen={isOpen}
        size="sm"
      >
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>
              <ModalBody className=" text-foreground-400 text-sm py-0">
                {description}
              </ModalBody>
              <ModalFooter>
                <Button
                  color={cancelColor}
                  variant="light"
                  onPress={() => setIsOpen(false)}
                >
                  {cancelText}
                </Button>
                <Button
                  color={approveColor}
                  isLoading={showLoading}
                  spinner={<Spinner />}
                  onPress={approveAction}
                >
                  {approveText}
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ConfirmAlert;
